import ProductVariant from '../../../domains/ProductVariant'
import { Cart } from '../../../services/cartService/cart.service.types'

export const isLineItemExist = (newCheckout: Cart, selectedVariant: ProductVariant) => {
  const lineItem = (newCheckout.lineItems as any)?.find?.((item: any) => item.variantId === selectedVariant.id)
  const lineItemExist = !!lineItem
  return lineItemExist
}
